/* eslint-disable no-nested-ternary */
import React from 'react';
import { isMobile } from 'react-device-detect';
import { ContentWrapper } from './ConfirmationPage.style';
import sentVideo from '../../images/sentVideo.mp4';

const ConfirmationPage = () => {
  if (isMobile) {
    return (
      <div className="ncss-row ta-sm-c mt6-sm mb6-sm">
        <div className="ncss-col-sm-12">
          <div className="ncss-row">
            <video
              className=""
              src={sentVideo}
              alt="video"
              height="240px"
              width="320px"
              autoPlay

            />
          </div>
          <div className="ncss-container">
            <div className="ncss-row pt5-sm pb5-sm ml6-sm mr6-sm">
              <div className="ncss-col-sm-12 ta-sm-c va-sm-m">
                <p
                  style={{
                    color: '#111111',
                    fontSize: '36px',
                    fontFamily: 'HelveticaNeue-Medium'
                  }}
                >
                  Thank You!
                </p>
              </div>
              <div className="ncss-col-sm-12 ta-sm-c va-sm-m">
                <p
                  style={{
                    fontFamily: 'HelveticaNeue',
                    fontSize: '16px',
                    color: '#767676'
                    // width: '10'
                  }}
                >
                  {`Thank you for your submission! Your teammate(s) and their manager will be notified
                  via email.`}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="ncss-col-sm-12 mt6-sm">
          <div className="ncss-row ta-sm-c mt6-sm mb6-sm">
            <a
              href={`${window.location.origin}/submit`}
              style={{
                background: '#111',
                color: '#ffffff',
                /* top | right | bottom | left */
                padding: '5px 3em 5px 3em',
                margin: '2em 4em',
                display: 'inline-block',
                borderRadius: '5em',
                fontSize: '16px',

              }}
            >
              Send another High Five
            </a>
          </div>
        </div>
      </div>
    );
  }
  return (
    <ContentWrapper>
      <div className="ncss-row ta-sm-c mt6-sm mb6-sm">
        <div className="ncss-col-sm-6">
          <div className="ncss-row">
            <video
              className=""
              src={sentVideo}
              alt="video"
              height="360px"
              width="648px"
              autoPlay

            />
          </div>
          <div className="ncss-container">
            <div className="ncss-row pt5-sm pb5-sm ml6-sm mr6-sm">
              <div className="ncss-col-sm-6 ta-sm-l va-sm-m">
                <p
                  style={{
                    color: '#111111',
                    fontSize: '36px',
                    fontFamily: 'HelveticaNeue-Medium'
                  }}
                >
                  Thank You!
                </p>
              </div>
              <div className="ncss-col-sm-6 ta-sm-l pl12-sm va-sm-m">
                <p
                  style={{
                    fontFamily: 'HelveticaNeue',
                    fontSize: '16px',
                    paddingLeft: '5px',
                    color: '#767676',
                    width: '316px'
                  }}
                >
                  {`Thank you for your submission! Your teammates and their manager will be notified
                  via email.`}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="ncss-col-sm-12 mt6-sm">
          <div className="ncss-row ta-sm-c mt6-sm mb6-sm">
            <a
              href={`${window.location.origin}/submit`}
              style={{
                background: '#111',
                color: '#ffffff',
                /* top | right | bottom | left */
                padding: '5px 3em 5px 3em',
                margin: '2em 4em',
                display: 'inline-block',
                borderRadius: '5em',
                fontSize: '16px',

              }}
            >
              Send another High Five
            </a>
          </div>
        </div>
      </div>
    </ContentWrapper>
  );
};

export default ConfirmationPage;



// WEBPACK FOOTER //
// ./src/containers/ConfirmationPage/ConfirmationPage.js